<template>
  <el-main class="container">
    <Nav>
      <div slot="left">
        <span :class="[select ? 'black' : '']" @click="event().change('add')">增值服务</span>
        <span :class="[!select ? 'black' : '']" @click="event().change('fun')">会议功能</span>
      </div>
      <div slot="right">
        <el-button type="primary" @click="event().getContent()" v-if="select">基础服务设置</el-button>
        <el-button type="primary" @click="handlerRouter('add-basic')" v-if="select">新增增值服务</el-button>
        <el-button type="primary" @click="event().getContent()" v-if="!select">会议功能说明</el-button>
        <el-button type="primary" @click="handlerRouter('add-meeting')" v-if="!select">新增会议功能</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      v-show="select"
      :config="config"
      class="table"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <div>
            <span
              class="details"
              @click="handlerRouter('addSet', scope)">
              编辑</span>
            <span
              class="details"
              @click="event().deleteServer(scope)">
              删除</span>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <table-pagination
      ref="table"
      v-show="!select"
      :config="config1"
      :datasource="datasource"
      class="table"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <div>
            <span
              class="details"
              @click="handlerRouter('meetingSet', scope)">
              编辑</span>
            <span
              class="details"
              @click="event().deleteMeetingFun(scope)">
              删除</span>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
    <el-dialog
      :visible.sync="showDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px">
      <div class="title" v-if="select">基础服务设置</div>
      <div class="title" v-if="!select">会议功能说明</div>
      <el-input
        v-model="basicBody.content"
        type="textarea"
        rows='18'
        clearable
        ></el-input>
        <div class="btn-box">
          <el-button @click="showDialog=false">取消</el-button>
          <el-button type="primary" @click="event().save()">保存</el-button>
        </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getAddServerList, deleteServer, setBasicServer, getMeetingFunList, deleteMeetingFun, setMeetingFun, getMeetingFun, getBasicServer } from '@/api/meeting'
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
export default {
  // inject:['reload'],//注入reload方法
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1
      },
      basicBody: {
        content: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'indexNum',
            label: '排列序号',
            width: '200'
          },
          {
            prop: 'name',
            label: '增值服务名称'
          },
          {
            prop: 'price',
            label: '单价'
          },
          {
            prop: 'unit',
            label: '单位'
          }
        ]
      },
      config1: {
        size: 10,
        fields: [
          {
            prop: 'indexNum',
            label: '排列序号',
            width: 400
          },
          {
            prop: 'name',
            label: '会议功能名称',
            width: 600
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      uuid: '',
      select: true,
      showDialog: false
    }
  },
  mounted() {
    this.datasource
    if (this.$route.query) {
      if (this.$route.query.select === false) {
        this.select = false
        this.network().getMeetingFunList()
      }
    }
    if (this.select) this.network().getAddServerList()
  },
  methods: {
    event() {
      return {
        deleteServer: (scope) => {
          this.$confirm('是否删除该增值服务？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteServer(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        deleteMeetingFun: (scope) => {
          this.$confirm('是否删除该会议功能？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteMeetingFun(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        save: () => {
          if (!this.basicBody.content) {
            this.$message({
              type: 'warning',
              message: '请输入内容'
            })
          } else if (this.select) {
            this.network().setBasicServer()
          } else this.network().setMeetingFun()
        },
        getContent: () => {
          this.showDialog = true
          if (this.select) this.network().getBasicServer()
          else this.network().getMeetingFun()
        },
        change: (e) => {
          if (e === 'fun') {
            this.select = false
            this.event().claer()
            this.network().getMeetingFunList()
          } else {
            this.select = true
            this.event().claer()
            this.network().getAddServerList()
          }
        },
        claer: () => {
          this.body.pageIndex = 1
          this.datasource.total = 0
          this.datasource.data = []
        }
      }
    },
    network() {
      return {
        getAddServerList: async() => {
          const { data } = await getAddServerList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteServer: async(uuid) => {
          await deleteServer(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getAddServerList()
        },
        deleteMeetingFun: async(uuid) => {
          await deleteMeetingFun(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getMeetingFunList()
        },
        setBasicServer: async() => {
          await setBasicServer(this.basicBody)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.showDialog = false
        },
        getMeetingFunList: async() => {
          const { data } = await getMeetingFunList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        setMeetingFun: async() => {
          await setMeetingFun(this.basicBody)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.showDialog = false
        },
        getBasicServer: async() => {
          const { data } = await getBasicServer()
          this.basicBody.content = data.content
        },
        getMeetingFun: async() => {
          const { data } = await getMeetingFun()
          this.basicBody.content = data.content
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      if (this.select) this.network().getAddServerList()
      else this.network().getMeetingFunList()
    },
    handlerRouter(type, scope) {
      if (type === 'addSet') {
        this.$router.push({ path: `/metting-management/server-management/set`, query: { info: scope }})
      } else if (type === 'add-basic') {
        this.$router.push(`/metting-management/server-management/add`)
      } else if (type === 'meetingSet') {
        this.$router.push({ path: `/metting-management/server-management/funtion-set`, query: { info: scope }})
      } else this.$router.push(`/metting-management/server-management/funtion-add`)
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  // @media screen and (min-width: 1751.2px){
  //   &{
  //     font-size: 7px;
  //   }
  // }
  .title{
    margin: -40px 0 30px 0;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }
  .btn-box{
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  span{
    margin-right: 30px;
    cursor: pointer;
  }
  .black{
    font-weight: bold;
  }

  Nav{
    margin-bottom: 10px;
  }

  /deep/ .table{
    /deep/ .el-table__body .el-table__row{
      height: 80px;
    }
  }
}
</style>
